var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7842 0.161592C18.6457 -0.177286 19.6259 0.0266625 20.2804 0.681155C20.9349 1.33565 21.1388 2.31661 20.8007 3.17738L14.3729 19.525C14.0038 20.4656 13.0686 21.0596 12.0605 20.9952C11.0516 20.9309 10.2001 20.2229 9.95276 19.2435L8.39097 13.0576C8.3204 12.78 8.10327 12.5628 7.82488 12.4946L1.76773 10.9972C0.785216 10.7537 0.0717796 9.90299 0.00508955 8.89256C-0.0616005 7.88135 0.532403 6.94381 1.47537 6.57314L17.7842 0.161592ZM18.3518 1.60473L2.04224 8.01706C1.72817 8.14036 1.53043 8.45287 1.55292 8.78942C1.57463 9.12675 1.8127 9.41057 2.13995 9.49122L8.1971 10.9886C9.0315 11.1949 9.68445 11.8448 9.8946 12.6776L11.4564 18.8635C11.5386 19.19 11.8224 19.4265 12.159 19.4474C12.4947 19.4691 12.8065 19.2714 12.9298 18.9573L19.3568 2.61051C19.47 2.32281 19.4018 1.99634 19.1839 1.77844C18.9652 1.55976 18.6387 1.49151 18.3518 1.60473ZM14.5854 5.29905C14.8878 4.99662 15.3795 4.99662 15.6819 5.29905C15.9843 5.60148 15.9843 6.09313 15.6819 6.39556L11.0291 11.0484C10.7267 11.3508 10.235 11.3508 9.9326 11.0484C9.63017 10.7459 9.63017 10.2543 9.9326 9.95184L14.5854 5.29905Z",
    fill: "#1B224C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveredIcon);
export default __webpack_public_path__ + "static/media/deliveredIcon.113eb62d99e6eaec1ec86b286dc3464e.svg";
export { ForwardRef as ReactComponent };